import Icons from '../../../../assets/index';

interface NumberInputProps {
  label: string;
  description?: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  required?: boolean;
  className?: string;
}

const NumberInput: React.FC<NumberInputProps> = ({
  label,
  description,
  value,
  onChange,
  min = 0,
  max = 100,
  required = false,
  className = '',
}) => {
  const handleIncrement = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value, 10);
    if (!isNaN(newValue) && newValue >= min && newValue <= max) {
      onChange(newValue);
    }
  };

  return (
    <div className={`w-full ${className}`}>
      <div className="flex items-center mb-1">
        <label className="text-sm font-medium text-gray-700">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      </div>
      {description && <p className="text-xs text-gray-500 mb-2">{description}</p>}
      <div className="inline-flex items-center bg-white rounded-xl border-2 border-ds-gray-100 overflow-hidden w-fit">
        <button
          type="button"
          onClick={handleDecrement}
          disabled={value <= min}
          className="w-20 h-10 flex items-center justify-center bg-ds-gray-50 hover:bg-gray-100 disabled:opacity-50 border-r-2 border-ds-gray-100"
        >
          <span className="text-xl text-gray-600">
            <Icons.minusIcon />
          </span>
        </button>
        <input
          type="text"
          value={value}
          onChange={handleInputChange}
          className="w-20 h-10 text-center bg-ds-gray-50 "
          aria-label={`${label} input field`}
        />
        <button
          type="button"
          onClick={handleIncrement}
          disabled={value >= max}
          className="w-20 h-10 flex items-center justify-center bg-ds-gray-50 hover:bg-gray-100 disabled:opacity-50 border-l-2 border-ds-gray-100 "
        >
          <span className="text-xl text-gray-600">
            <Icons.plusIcons />
          </span>
        </button>
      </div>
    </div>
  );
};

export default NumberInput;
